export default "__VITE_ASSET__C6F6Vx5b__"